import { PCTool } from './PCTool'
import { GeomDataHolder, SPolygon } from '../ImportHelper'
import { endEventCreator, addPointCreator } from './EventCreator'

class CloudPolygonTool extends PCTool {
    constructor (panogl) {
        super(panogl, SPolygon, GeomDataHolder.POLYGON)
        this.type = 'Polygon'
    }

    endDraw () {
        let dh = this.dh
        let pointNumber = dh.getPointLength()
        let isSuccessful = false
        if (pointNumber < 3) {
            dh.setStatus(GeomDataHolder.STATUS.BAD_COMPLETED)
        } else {
            isSuccessful = true
            dh.setStatus(GeomDataHolder.STATUS.COMPLETED)
        }
        this.throwEvent(endEventCreator(this.type, isSuccessful, this.dh))
    }

    addPoint (point) {
        if (Array.isArray(point)) {
            this._points.push(point)
            this.update()
            this.throwEvent(addPointCreator(this.type, true, this.dh, point))
        } else {
            this.throwEvent(addPointCreator(this.type, false, this.dh, null))
        }
    }

    onPointsReceived (points) {
        let pt = points[0]
        this.addPoint(pt)
    }

    update () {
        let dh = this.dh
        dh.resetPoints()
        dh.setPoints(this._points.map(([lon, lat, alt]) => ({ lon, lat, alt })))
    }
}

export { CloudPolygonTool }
